import * as React from 'react';
import { resolve } from 'inversify-react';
import { Link } from 'react-router-dom';

import { DataTableView, Column, ToolbarVisibility } from 'src/core/ui/data-table.view';
import { FormatService } from 'src/core/services/format.service';

export class MarketListView extends React.Component<MarketListViewProps, any> {
	@resolve
	private formatService: FormatService;

	columns: Column[] = [
		{
			key: 'name',
			title: 'Name',
			dataIndex: 'name',
			render: (text, record: MarketSummary) => <Link to={`/general/market/${record.id}`}>{text}</Link>,
		},
		{
			key: 'displayName',
			title: 'Description',
			dataIndex: 'displayName'
		},
		{
			key: 'defaultMargin',
			title: 'Default Margin',
			dataIndex: 'defaultMargin',
			render: (text: any, record: MarketSummary, index: number) => this.formatService.toString('percent-full', record.defaultMargin)
		},
		{
			key: 'marginPolicyText',
			title: 'Margin Policy',
			dataIndex: 'marginPolicyText'
		}
	];

	constructor(props: any) {
		super(props);
	}

	render() {
		const model = this.props.model;
		const items = model.items.map(o => o);

		return (
			<div className="window window-normal">
				<div className="panel">
					<DataTableView
						setBusy={this.props.setBusy}
						columns={this.columns}
						model={model}
						itemDoubleClick={(item) => { if (this.props.onItemDoubleClicked) { this.props.onItemDoubleClicked(item); } }} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/market/list/market-list.view.tsx